<div class="table-loader">
  <span class="txt">Loading</span>
  <div class="spinner-border spinner-border-sm" role="status">
    <span class="visually-hidden"></span>
  </div>
</div>
